import { combineReducers } from "redux";
import user from "./user/userReducer";
import admin from "./admin/adminReducer";
import company from "./clients/company/companyReducer";
import groups from "./clients/groups/groupsReducer";
import url from "./authentication/authentication";
import rgpd from "./rgpd/rgpdReducer";
import products from "./imagedatabase/productsReducer";
import productsFamilies from "./imagedatabase/productsFamiliesReducer";

import { LOGOUT } from "../actions/authentication/authentication";

const appReducer = combineReducers({
  user: user,
  admin: admin,
  url: url,
  company: company,
  groups: groups,
  products: products,
  productsFamilies: productsFamilies,
  rgpd: rgpd,
});

const urlReducer = (state, action) => {
  if (action.type === LOGOUT) {
    // Wipe all redux state
    state = undefined;
  }

  return appReducer(state, action);
};

export default urlReducer;
